module.exports = __webpack_public_path__ + "img/aladin.ee09b15f.jpg";